import gql from "graphql-tag"

import partialUser from "@irati/identity/services/fragments/PartialUser"

const query = gql`
  query RecognitionWithTeams($id: String!) {
    recognition(id: $id) {
      uuid
      createdAt
      message
      moderated
      private
      expectReward
      receivers {
        results {
          ...partialUser
          teams {
            results {
              teamName
            }
          }
        }
      }
      teams {
        results {
          uuid
          public_name
        }
      }
      createdBy {
        ...partialUser
        teams {
          results {
            teamName
          }
        }
      }
      occasion {
        uuid
        name
        default
        icon {
          href
          alt
        }
        archived
      }
      companyValues {
        results {
          archived
          name
          tag
          uuid
        }
      }
    }
  }
  ${partialUser}
`

export default query
